import EventEmitter from "./EventEmitter";

export default class Time extends EventEmitter {
  constructor() {
    super();

    // Set up
    this.start = Date.now();
    this.current = this.start;
    this.elapsed = 0;
    this.deltaTime = 16.6667;

    // Listeners
    window.requestAnimationFrame(() => {
      this.tick();
    });
  }

  tick() {
    const currentTime = Date.now();

    // Update time values
    this.deltaTime = currentTime - this.current;
    this.current = currentTime;
    this.elapsed = this.current - this.start;

    this.trigger("tick");

    // Call tick again on the next frame
    window.requestAnimationFrame(() => {
      this.tick();
    });
  }
}
